// Automatic-carousel wizard (carousels/_form.html.erb, admin/carousels/_form.html.erb):
// keeps the display pages in sync with whichever Type/kind radio is selected. A handful of
// "Page(s) d'affichage" checkboxes are reserved for one specific kind (e.g. the
// "Meilleures ventes" page should only ever be fed by a best_seller carousel) — see
// CarouselsHelper::PAGE_KINDS_BY_NAME (and .cohort_page_kinds), which the view turns into each checkbox's
// `data-kinds` (a space-separated list of eligible kinds; absent = no restriction).
// Also, with cohort curation, each cohort's display pages are only shown while that cohort is selected
// (the server ignores pages of unselected cohorts).
// The latest releases offer their publication period along their kind (carousels/_release_period.html.erb).
const KIND_SELECTOR = 'input[name="carousel[kind]"]';
const PAGE_CHECKBOX_SELECTOR = 'input[name="carousel[display][pages][]"], input[name="carousel[display][cohort_page_ids][]"]';
const COHORT_SELECTOR = 'input[name="carousel[display][cohort_ids][]"]';

const applyKindFilter = (form) => {
  const selectedKind = form.querySelector(`${KIND_SELECTOR}:checked`)?.value;
  if (!selectedKind) return;

  const periods = form.querySelector('[data-release-period]');
  if (periods) periods.hidden = selectedKind !== 'recent';

  form.querySelectorAll(PAGE_CHECKBOX_SELECTOR).forEach((checkbox) => {
    const kinds = checkbox.dataset.kinds;
    const eligible = !kinds || kinds.split(' ').includes(selectedKind);
    const wrapper = checkbox.closest('.form-check');
    if (wrapper) wrapper.hidden = !eligible;
    if (!eligible && checkbox.checked) checkbox.checked = false;
  });
};

document.addEventListener('change', (event) => {
  if (event.target.matches(COHORT_SELECTOR)) {
    const pages = event.target.form.querySelector(`[data-cohort-pages="${event.target.value}"]`);
    if (pages) pages.hidden = !event.target.checked;
    return;
  }
  if (!event.target.matches(KIND_SELECTOR)) return;
  applyKindFilter(event.target.form);
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(KIND_SELECTOR).forEach((radio) => {
    if (radio.checked) applyKindFilter(radio.form);
  });
});
